import { useModal } from "../../context/ModalContext";

export default function GlobalModalOverlay() {
  const { modal, closeModal } = useModal();

  if (!modal) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">{modal.title || "Confirm"}</h5>
            <button className="btn-close" onClick={closeModal}></button>
          </div>

          <div className="modal-body">
            <p>{modal.content}</p>
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={closeModal}>Cancel</button>
            <button className="btn btn-danger" onClick={() => {
              modal.onConfirm?.();
              closeModal();
            }}>Confirm</button>
          </div>

        </div>
      </div>
    </div>
  );
}
